import { MutableRefObject, useRef } from 'react';

import { NwApplicationServiceTypes } from '../../services/NwApplicationServices/APIService';
import { NwApplicationService } from '../../services/NwApplicationServices/APIService/index.api';
import { networkCallWithApisauce } from '../../utils/AuthAPIUtils';

interface NwApplicationServiceInstance {
  nwApplicationPublicService: NwApplicationServiceTypes;
}

const useNwApplicationServicePublic = (): NwApplicationServiceInstance => {
  const nwApplicationServicePublicRef: MutableRefObject<NwApplicationServiceTypes | null> =
    useRef(null);

  if (nwApplicationServicePublicRef.current === null) {
    nwApplicationServicePublicRef.current = new NwApplicationService(
      networkCallWithApisauce
    );
  }

  return {
    nwApplicationPublicService: nwApplicationServicePublicRef.current
  };
};

export { useNwApplicationServicePublic };
